import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfContratos, ITiposGeneralesContrato } from '@/modules/Contratacion/interfaces'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type { AxiosResponse } from 'axios'
import type { IConfBasedatosPacientes } from '@/modules/Administracion/interfaces'
import type { ServicioRelacionInput } from '@/modules/Core/utils/contratos'
export class ContratoService extends BaseService<IConfContratos> {
  constructor() {
    super({
      baseUrl: 'system/contracts/'
    })
  }
  async generales(): Promise<AxiosResponse<IResponseApi<ITiposGeneralesContrato>>> {
    return this.http.get<IResponseApi<ITiposGeneralesContrato>>(`/general`)
  }
  async listByPaciente(coppId: number): Promise<AxiosResponse<IResponseApi<IConfBasedatosPacientes[]>>> {
    return this.http.get<IResponseApi<IConfBasedatosPacientes[]>>(`/listByPaciente/${coppId}`)
  }
  async listByPacienteContrato(params: { fecha: string, copeId: number, servicio?: ServicioRelacionInput[] }): Promise<AxiosResponse<IResponseApi<{ capitado: IConfContratos[]; evento: IConfContratos[] }>>> {
    return this.http.post<IResponseApi<{ capitado: IConfContratos[]; evento: IConfContratos[] }>>(`/buscar-contratos-vigentes`, { params }).catch(this.errorHandle)
  }
  async listVigentes(fecha: string): Promise<AxiosResponse<IResponseApi<{ capitado: IConfContratos[]; evento: IConfContratos[] }>>> {
    return this.http.post<IResponseApi<{ capitado: IConfContratos[]; evento: IConfContratos[] }>>(`/buscar-contratos-vigentes`, { params: { fecha } }).catch(this.errorHandle)
  }
  async listPacientesByContrato(cocoId: number, fecha: string): Promise<AxiosResponse<IResponseApi<number[]>>> {
    return this.http.get<IResponseApi<number[]>>(`/listPacientesByContrato/${cocoId}/${fecha}`).catch(this.errorHandle)
  }
}